<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink"
       width="100%"
       height="100%"
       viewBox="-25 0 230 255">
    <path fill-rule="evenodd"
          stroke="rgb(38, 87, 112)"
          stroke-width="2px"
          stroke-dasharray="6, 4"
          stroke-linecap="butt"
          stroke-linejoin="miter"
          opacity="0.502"
          s
          fill="none"
          d="M32.562,343.000 C32.562,343.000 30.647,317.040 30.452,311.854 C30.258,306.668 29.345,303.656 26.232,301.784 C23.119,299.913 8.703,293.185 4.077,275.673 C-0.549,258.160 1.645,204.193 4.187,190.081 C6.729,175.969 13.256,129.528 17.902,117.580 C22.549,105.632 35.897,91.510 42.057,88.406 C48.218,85.302 56.829,82.426 61.103,79.344 C65.377,76.261 66.563,75.605 66.433,72.267 C66.303,68.928 66.621,64.421 64.268,62.197 C61.914,59.974 57.819,55.535 56.883,49.107 C56.335,45.350 59.218,43.021 61.103,42.058 C62.987,41.095 61.049,32.100 61.048,27.961 C61.046,21.537 68.018,10.317 74.763,5.808 C84.975,-1.021 103.429,-0.269 112.743,6.815 C122.057,13.898 125.403,21.028 125.403,27.961 C125.403,33.278 121.308,39.710 123.293,41.051 C126.028,42.899 127.858,45.949 127.513,49.107 C126.818,55.467 122.604,57.824 120.128,60.183 C116.937,63.224 116.337,69.097 116.963,72.267 C117.589,75.437 121.417,78.058 124.348,79.344 C126.723,80.385 135.694,84.427 141.228,87.399 C153.575,94.030 160.740,106.950 164.328,114.559 C177.709,142.936 180.602,181.270 181.209,190.081 C181.815,198.893 186.191,261.586 180.319,278.694 C175.928,291.483 160.867,299.685 154.000,302.000 C150.399,303.214 150.258,311.121 150.000,314.000 C149.587,318.616 148.613,344.000 148.613,344.000 " />
  </svg>
</template>

<script setup lang="ts">

</script>

<style scoped lang="less">
svg {
  width: 100%;
  height: 100%;
}
</style>
